/**
 * FASE 22.1 — WORKFLOW TIMELINE
 *
 * Ring buffer of workflow lifecycle events.
 * Session-scoped — not persisted (resets on page load).
 * Used for the dev debug surface and future audit integration.
 */

const MAX_EVENTS = 30;

/** @type {Array<{id, workflowId, type, ts, meta}>} */
const _events = [];
let _seq = 0;

export const WF_TIMELINE_EVENTS = Object.freeze({
  CREATED:   "WF_CREATED",
  UPDATED:   "WF_UPDATED",
  COMPLETED: "WF_COMPLETED",
  PAUSED:    "WF_PAUSED",
  RESUMED:   "WF_RESUMED",
  ARCHIVED:  "WF_ARCHIVED",
  STEP_DONE: "WF_STEP_DONE",
});

export function pushWorkflowEvent({ workflowId, type, meta = {} }) {
  if (_events.length >= MAX_EVENTS) _events.shift();
  _events.push({
    id:         `wft_${++_seq}`,
    workflowId,
    type,
    ts:         Date.now(),
    meta,
  });
}

export function getWorkflowTimeline() {
  return [..._events];
}

export function clearWorkflowTimeline() {
  _events.length = 0;
}
